import React from "react";

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function NationwideIcon({ size = 20, color = "white", className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M3.62504 11.6484C3.54645 11.6484 3.46855 11.6247 3.40219 11.5786C3.29707 11.5056 3.23438 11.3858 3.23438 11.2578V1.74998C3.23438 1.62201 3.29707 1.50213 3.40219 1.42912C3.5073 1.35619 3.64148 1.33927 3.76145 1.38396L16.5114 6.13787C16.6643 6.19486 16.7656 6.34076 16.7656 6.50388C16.7656 6.66701 16.6643 6.81291 16.5114 6.8699L3.76145 11.6238C3.71723 11.6403 3.67102 11.6484 3.62504 11.6484ZM4.01562 2.31252V10.6953L15.2569 6.50388L4.01562 2.31252Z" fill={color}/>
      <path d="M3.625 20C3.40926 20 3.23438 19.8251 3.23438 19.6094V0.390625C3.23438 0.174922 3.40926 0 3.625 0C3.84074 0 4.01562 0.174922 4.01562 0.390625V19.6094C4.01562 19.8251 3.84074 20 3.625 20Z" fill={color}/>
    </svg>
  );
}
